import { render, staticRenderFns } from "./FuVerticalNavigation.vue?vue&type=template&id=4d954e2e&"
import script from "./FuVerticalNavigation.vue?vue&type=script&lang=js&"
export * from "./FuVerticalNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports